import React, {useEffect, useState} from "react";
import {Button, Card, Input, message, Space, Table, Upload} from "antd";
import {getHostAddress} from "../../Tool/UtileFun"
import {TeacherTabButton} from "./TeacherTabButton";
import {UploadOutlined} from "@ant-design/icons";
import {ButtonAndModal} from "../StudentPage/ButtonAndModal";

export function TeacherTable(){


    useEffect(
        ()=>{
            findTaskAll()
        },[]
    );



    const findTaskAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/user/findByTeacher",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setTask(data)
            })
            .catch(error => message.error("error"+error));
    }

    const searchStudent=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/user/searchTeacherNew",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({name:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setTask(data)
            })
            .catch(error => message.error("error"+error));
    }


    const [task,setTask]=useState([]);

    const { Search } = Input;

    const columns = [
        {
            title: '序号',
            width:80,
            render:(text,record,index)=>`${index+1}`

        },
        {
            title: '工号',
            dataIndex: 'studentNumber',
            key: 'studentNumber',
        },
        {
            title: '姓名',
            dataIndex: 'realName',
            key: 'realName',
        },
        {
            title: '班级',
            dataIndex: 'className',
            key: 'className',
        },
        {
            title: "电话号码",
            dataIndex: "telNumber",
            key:"telNumber",
        },
        // {
        //     title: '操作',
        //     key: 'details',
        //     render: (taskInfo) => (
        //         <>
        //             <Space size="middle">
        //                 <TeacherTabButton props={taskInfo}
        //                            Event={()=>{
        //                                findTaskAll()
        //                                console.log("执行了")
        //                            }}
        //                 ></TeacherTabButton>
        //             </Space>
        //         </>
        //     ),
        // },
        {
            title: '操作',
            key: 'details',
            render: (userInfo) => (
                <>
                    <Space size="middle">
                        <ButtonAndModal props={userInfo}
                                        Event={()=>{
                                            findTaskAll()
                                        }}
                        ></ButtonAndModal>
                    </Space>
                </>
            ),
        },

    ];


    const propsData = {
        name: 'file',
        listType: 'video',
        action: "http://"+getHostAddress()+"/batchImportApi/importTeacher",
        headers: {
            authorization: 'authorization-text',
        },
        beforeUpload(file) {
            console.log(file.name)
            if (file.size > 1048576*500){
                message.info("上传文件最大支持500MB")
                return false
            }
            let fileName = file.name
            let format = ""
            let realFormat = ""
            for (let i = fileName.length - 1; i >= 0; i--) {
                console.log(fileName[i])
                if (fileName[i] === "."){
                    break
                }
                if (fileName[i] !== "."){
                    format = format + fileName[i]
                }
            }

            for (let i = format.length - 1 ; i >= 0 ; i--) {
                if (format[i] !=="."){
                    realFormat = realFormat + format[i]
                }
            }
            if (realFormat!=="xlsx"){
                message.info("仅支持xlsx格式的视频")
                return false
            }
            return true
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
                console.log("返回")
                console.log(info.file.response)
            }
            if (info.file.status === 'done' && info.file.response.state === 'success') {
                message.success(`${info.file.name} 文件上传成功`);
                findTaskAll()
            } else if (info.file.status === 'error' && info.file.response.state === 'error') {
                message.error(`${info.file.name} 文件上传失败`);
            }
        },
    };

    return(
        <Card title={"教师管理"}>
            <Search placeholder="输入教师名称搜索"
                    onSearch={value => searchStudent(value)}
                    enterButton
                    style={{width:500}}/>
            <Upload {...propsData}>
                <Button icon={<UploadOutlined />}>导入老师</Button>
            </Upload>
            <Table
                columns={columns}
                dataSource={task}
                pagination={{
                    onChange: page => {
                        console.log(page);
                    },
                    pageSize: 5,
                }}
            ></Table>
        </Card>
    )
}
